export const format_currency = (value: number | string) => {
  const num = Number(value);
  return isNaN(num) ? 'Invalid Value' : '$ ' + new Intl.NumberFormat().format(num);
};
